import { Routes } from '@angular/router';
import { AuthGuard } from './core/AuthGuard';
import { NoAuthGuard } from './core/no-auth.guard';
import { RouteGuard } from './core/RouteGuard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'nuova-prenotazione',
    loadComponent: () => import('./pages/prenota/prenota.component').then(m => m.PrenotaComponent),
    canActivate: [AuthGuard, RouteGuard]
  },
  {
    path: 'le-tue-prenotazioni',
    loadComponent: () => import('./pages/appuntamenti/gestione-appuntamenti-cliente/gestione-appuntamenti-cliente.component').then(m => m.GestioneAppuntamentiClienteComponent),
    canActivate: [AuthGuard, RouteGuard]
  },
  {
    path: 'lista-attesa',
    loadComponent: () => import('./pages/lista-attesa/lista-attesa.component').then(m => m.ListaAttesaComponent),
    canActivate: [AuthGuard, RouteGuard]
  },
  {
    path: 'novita',
    loadComponent: () => import('./pages/novita/novita.component').then(m => m.NovitaComponent),
    canActivate: [AuthGuard, RouteGuard]
  },
  {
    path: 'nuova-prenotazione-admin',
    loadComponent: () => import('./pages/appuntamenti/nuova-prenotazione-admin/nuova-prenotazione-admin.component').then(m => m.NuovaPrenotazioneAdminComponent),
    canActivate: [AuthGuard, RouteGuard]
  },
  {
    path: 'gestisci-prenotazioni',
    loadComponent: () => import('./pages/appuntamenti/gestione-appuntamenti-admin/gestione-appuntamenti-admin.component').then(m => m.GestioneAppuntamentiAdminComponent),
    canActivate: [AuthGuard, RouteGuard]
  },
  {
    path: 'gestisci-disponibilita',
    loadComponent: () => import('./pages/gestione-disponibilita/gestione-disponibilita.component').then(m => m.GestioneDisponibilitaComponent),
    canActivate: [AuthGuard, RouteGuard]
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login/login.component').then(m => m.LoginComponent),
    canActivate: [NoAuthGuard]
  },
  {
    path: 'register',
    loadComponent: () => import('./pages/register/register/register.component').then(m => m.RegisterComponent),
    canActivate: [NoAuthGuard]
  },
  {
    path: 'confirm',
    loadComponent: () => import('./pages/confirm/confirm.component').then(m => m.ConfirmComponent),
    canActivate: [NoAuthGuard]
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./pages/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
    canActivate: [NoAuthGuard]
  },
  {
    path: 'impostazioni',
    loadComponent: () => import('./pages/settings/settings.component').then(m => m.SettingsComponent),
    canActivate: [AuthGuard, RouteGuard]
  },
  {
    path: 'contatti',
    loadComponent: () => import('./pages/contatti/contatti.component').then(m => m.ContattiComponent),
    canActivate: [AuthGuard, RouteGuard]
  },
  {
    path: 'profilo',
    loadComponent: () => import('./pages/profilo/profilo.component').then(m => m.ProfiloComponent),
    canActivate: [AuthGuard, RouteGuard]
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('./pages/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
  },
  {
    path: 'ego',
    loadComponent: () => import('./pages/ego/ego.component').then(m => m.EgoComponent)
  },
  { path: '**', redirectTo: '' }
];
